// Kontaktsidan som alla supportingångar (headerknappen, sidomenyns supportruta, sidfoten) länkar till.
// Håll destinationen här så att ingångarna inte kan glida isär.
export const SUPPORT_CONTACT_PATH = '/kontakt';
